import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import StylesProvider from '@mui/styles/StylesProvider';
// import StyledEngineProvider from '@mui/material/StyledEngineProvider';
// @ts-ignore
import createGenerateClassNameHash from '@mui/styles/createGenerateClassName/createGenerateClassNameHash';
import { createGenerateClassName } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import ISPROD from './lib/misc';
import debug from 'debug';

import { ThemeProvider, Theme, StyledEngineProvider } from '@mui/material/styles';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import theme from './Theme';

import Router from './Router';
import GlobalStylesHelper from 'components/Helpers/GlobalStyles';
import ShopifyProvider from 'contexts/ShopifyContext';
import CollectionsProvider from './contexts/CollectionsContext';
import PageProvider from './contexts/PagesContext';
import UIProvider from './contexts/UIContext';
// import { FixedSnackbarProvider } from 'lib/notistack';
import { IS_DEV } from 'environment';
import { SnackbarProvider } from 'notistack';

import CheckIcon from '@mui/icons-material/CheckCircleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

const generateClassNameDefault = createGenerateClassName({
  disableGlobal: false,
  productionPrefix: 'cg',
});

const generateClassNameProduction = createGenerateClassNameHash({});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false, // Never retry...
      staleTime: 60 * 1000 * 5,
      refetchOnWindowFocus: !IS_DEV, // Do not constantly refresh in DEV
    },
  },
});

if (IS_DEV) debug.enable('*,-kl_forms*');

const d = debug('app');

function App() {
  d('renderApp', theme);
  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider
        // @ts-ignore
        dateAdapter={AdapterDateFns}
      >
        <StylesProvider generateClassName={ISPROD ? generateClassNameProduction : generateClassNameDefault}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <SnackbarProvider
                anchorOrigin={{
                  horizontal: 'center',
                  vertical: 'top',
                }}
                iconVariant={{
                  success: <CheckIcon />,
                  error: <InfoOutlinedIcon />,
                  warning: <WarningAmberOutlinedIcon />,
                  info: <InfoOutlinedIcon />,
                }}
                // classes={{
                //   // @ts-ignore
                //   variantSuccess: {
                //     backgroundColor: 'orange',
                //   },
                //   variantWarning: 'CGSnack-warning',
                //   variantError: 'CGSnack-error',
                //   variantInfo: 'CGSnack-info',
                // }}
              >
                <GlobalStylesHelper />
                <CollectionsProvider>
                  <PageProvider>
                    <UIProvider>
                      <ShopifyProvider>
                        <Router />
                      </ShopifyProvider>
                    </UIProvider>
                  </PageProvider>
                </CollectionsProvider>
              </SnackbarProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </StylesProvider>
      </LocalizationProvider>
    </QueryClientProvider>
  );
}

export default App;
